import React from 'react';
import './About.css';
import JoseHeadshot from '../../assets/images/jose_headshot.jpg';
import BicycleIcon from '../../assets/icons/bicycle_icon.png';
import HighlightHeader from '../../assets/images/brush3.png';
import {Helmet} from 'react-helmet';

const teamMembers = [
    {
      name: 'Jose Barrionuevo',
      role: 'Founder & Product Analyst',
      photo: JoseHeadshot,
    },
  ];
  
  export default function AboutPage() {
    return (
      <>
      <Helmet>
        <title>About</title>
      </Helmet>
        <div className='about-page'>
          <section className='about-section'>
        <div className='about-wrapper'>
          <div className='highlight-header-about'>
              <img src={HighlightHeader} alt='highlighting texture'></img>
            </div><h1>About Us <img className='bicycle-icon' src={BicycleIcon} alt='bicycle icon'></img></h1></div>
            <p>
              Resycle is a PoP (Proof of Product) created by Jose Barrionuevo. Its mission is to empower job seekers to find the right resume for their application.
            </p>
        
          </section>
    
          <section className='team-section'>
            <h2>Meet the Team</h2>
            <div className='team-grid'>
              {teamMembers.map(({ name, role, photo }) => (
                <div key={name} className='team-member'>
                  <a style={{textDecoration: 'none', color: 'var(--app-blue-black)'}}href='https://linkedin.com/in/josembarrionuevovii'>
                      <img src={photo} alt={name} className='member-photo' />
                  </a>
                  <a style={{textDecoration: 'none', color: 'var(--app-blue-black)'}}href='https://linkedin.com/in/josembarrionuevovii'><h3 className='member-name'>{name}</h3></a>
                  <p className='member-role'>{role}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </>
    );
  }


